export default {
  appConfig: {
    title: '绵阳智慧物业',
    copyright1: '版权公告：绵阳市住房和城乡建设委员会 版权所有 | ',
    copyright2: '技术支撑单位：四川广月科技有限公司 | ',
    copyright3: '蜀ICP备19021908号-6',
    title_1: '绵阳智慧物业物联',
    icon: {
      logo: 'logo/28_28.png',
      logo1: 'logo/400_64.png',
      logo2: 'logo/40_40.png',
    },
  },
  navTheme: 'light', // 菜单栏的背景色 dark, light
  primaryColor: '#44bb55', // primary color of ant design
  menuLayout: 'sidemenu', // 菜单位置: 侧边栏 sidemenu 和顶部栏 topmenu
  verifyLogin: {
    requiredLogin: false, // 配置是否需要验证登录
    backIndex: '/login', // 验证不通过返回页面
    noVerify: ['/login'], // 配置不需要验证的页面
  },
  defaultMenu: [
    {
      category: 'BASE',
      id: '613c4009b80bf60dcd0e7a61',
      method: 'GET',
      name: '首页',
      quickEntry: false,
      serviceName: 'gmrfid-service-user',
      sort: 0,
      type: 'MENU',
      uri: '/',
      value: '/',
    },
    {
      category: 'BASE',
      children: [
        {
          category: 'BASE',
          id: '61a040d29b80260051c15c23',
          method: 'GET',
          name: '通讯录管理',
          parentId: '616f7aafa507dc68d250f712',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 110,
          type: 'MENU',
          disabled: true,
          uri: '/organization/addressListManage',
          value: '/organization/addressListManage',
        },
        {
          category: 'BASE',
          id: '61a5d25e1426206944b5841a',
          method: 'GET',
          name: '职位管理',
          parentId: '616f7aafa507dc68d250f712',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 120,
          disabled: true,
          type: 'MENU',
          uri: '/organization/positionManage',
          value: '/organization/positionManage',
        },
        {
          category: 'BASE',
          id: '61a9d7948f88176d251f44a8',
          method: 'GET',
          name: '申请列表',
          parentId: '616f7aafa507dc68d250f712',
          quickEntry: false,
          serviceName: 'gmrfid-service-community-api-manager',
          sort: 130,
          disabled: true,
          type: 'MENU',
          uri: '/organization/communicationApproval',
          value: '/organization/communicationApproval',
        },
      ],
      icon: 'mock/gmrfid-service-goods/service/kcI-Nu1DRNyF5l_JvIAHDg',
      icon2: 'mock/gmrfid-service-goods/service/lJ3W-dM6TImWMQfnrA-VBg',
      id: '616f7aafa507dc68d250f712',
      method: 'GET',
      name: '通讯录',
      quickEntry: false,
      serviceName: 'gmrfid-service-user-api-manager',
      sort: 100,
      type: 'MENU',
      uri: '/organization',
      value: '/organization',
    },
    {
      category: 'BASE',
      children: [
        {
          category: 'BASE',
          id: '619b7bf49054652adc74f057',
          method: 'GET',
          name: '应用管理',
          parentId: '619b7b699054652adc74f056',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 205,
          type: 'MENU',
          disabled: true,

          uri: '/workbench/applicationManager',
          value: '/workbench/applicationManager',
        },
        {
          category: 'BASE',
          id: '619b7c3ef908f33e1806ada6',
          method: 'GET',
          name: '第三方应用',
          parentId: '619b7b699054652adc74f056',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 210,
          type: 'MENU',
          disabled: true,

          uri: '/workbench/thirdParty',
          value: '/workbench/thirdParty',
        },
      ],
      icon: 'mock/gmrfid-service-goods/service/xVaSBaHLQ92ToGRuUPGyMw',
      icon2: 'mock/gmrfid-service-goods/service/rWVATQOvQWmB2aSFvJLXMg',
      id: '619b7b699054652adc74f056',
      method: 'GET',
      name: '工作台',
      quickEntry: false,
      serviceName: 'gmrfid-service-user',
      sort: 200,
      type: 'MENU',
      uri: '/workbench',
      value: '/workbench',
    },
    {
      category: 'BASE',
      children: [
        {
          category: 'BASE',
          id: '619c654e18085411ad312232',
          method: 'GET',
          name: '基本信息',
          parentId: '619c64ac18085411ad312231',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 305,
          type: 'MENU',
          disabled: true,

          uri: '/project/basicInformation',
          value: '/project/basicInformation',
        },
        {
          category: 'BASE',
          children: [
            {
              category: 'BASE',
              id: '619ddfef7f49120c1d005919',
              method: 'GET',
              name: '房屋档案',
              parentId: '619c661a18085411ad312234',
              quickEntry: false,
              serviceName: 'gmrfid-service-vote',
              sort: 9999,
              type: 'MENU',
              disabled: true,

              uri: '/project/propertyInformation/housingArchives',
              value: '/project/propertyInformation/housingArchives',
            },
            {
              category: 'BASE',
              id: '619de0637f49120c1d00591a',
              method: 'GET',
              name: '车位档案',
              parentId: '619c661a18085411ad312234',
              quickEntry: false,
              serviceName: 'gmrfid-service-vote',
              sort: 9999,
              disabled: true,

              type: 'MENU',
              uri: '/project/propertyInformation/parkingArchives',
              value: '/project/propertyInformation/parkingArchives',
            },
          ],
          id: '619c661a18085411ad312234',
          method: 'GET',
          name: '物业档案',
          parentId: '619c64ac18085411ad312231',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 310,
          type: 'MENU',
          uri: '/project/propertyInformation',
          value: '/project/propertyInformation',
        },
        {
          category: 'BASE',
          children: [
            {
              category: 'BASE',
              id: '619efdd364b3812f87f27aef',
              method: 'GET',
              name: '业主档案',
              parentId: '619c65ae18085411ad312233',
              quickEntry: false,
              serviceName: 'gmrfid-service-vote',
              sort: 9999,
              type: 'MENU',
              disabled: true,

              uri: '/project/householdInformation/householder',
              value: '/project/householdInformation/householder',
            },
            {
              category: 'BASE',
              id: '619efe0a64b3812f87f27af0',
              method: 'GET',
              name: '亲属管理',
              parentId: '619c65ae18085411ad312233',
              quickEntry: false,
              serviceName: 'gmrfid-service-vote',
              sort: 9999,
              type: 'MENU',
              disabled: true,

              uri: '/project/householdInformation/relatives',
              value: '/project/householdInformation/relatives',
            },
            {
              category: 'BASE',
              id: '619efe4364b3812f87f27af1',
              method: 'GET',
              name: '租户管理',
              parentId: '619c65ae18085411ad312233',
              quickEntry: false,
              serviceName: 'gmrfid-service-user',
              sort: 9999,
              type: 'MENU',
              disabled: true,

              uri: '/project/householdInformation/tenant',
              value: '/project/householdInformation/tenant',
            },
            {
              category: 'BASE',
              id: '619efe8d64b3812f87f27af2',
              method: 'GET',
              name: '住户审批',
              parentId: '619c65ae18085411ad312233',
              quickEntry: false,
              serviceName: 'gmrfid-service-user',
              sort: 9999,
              disabled: true,

              type: 'MENU',
              uri: '/project/householdInformation/residentApproval',
              value: '/project/householdInformation/residentApproval',
            },
          ],
          id: '619c65ae18085411ad312233',
          method: 'GET',
          name: '住户档案',
          parentId: '619c64ac18085411ad312231',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 320,
          type: 'MENU',
          uri: '/project/householdInformation',
          value: '/project/householdInformation',
        },
      ],
      icon: 'mock/gmrfid-service-goods/service/gFmN49oRQfuzhlMh2p-K4g',
      icon2: 'mock/gmrfid-service-goods/service/7W1-f4hDQBW9oT_ZOEhDzQ',
      id: '619c64ac18085411ad312231',
      method: 'GET',
      name: '项目信息',
      quickEntry: false,
      serviceName: 'gmrfid-service-user-api-manager',
      sort: 300,
      type: 'MENU',
      uri: '/project',
      value: '/project',
    },
    {
      category: 'BASE',
      children: [
        {
          category: 'BASE',
          id: '619e26787f49120c1d00591f',
          method: 'GET',
          name: '权限管理',
          parentId: '619e206806a549793810b034',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 410,
          type: 'MENU',
          disabled: true,
          uri: '/systemSettings/authorityManage',
          value: '/systemSettings/authorityManage',
        },
        {
          category: 'BASE',
          id: '619e29c97f49120c1d005920',
          method: 'GET',
          name: '操作日志',
          parentId: '619e206806a549793810b034',
          quickEntry: false,
          serviceName: 'gmrfid-service-user',
          sort: 420,
          disabled: true,
          type: 'MENU',
          uri: '/systemSettings/operateLog',
          value: '/systemSettings/operateLog',
        },
      ],
      icon: 'mock/gmrfid-service-goods/service/xt5SIm9IRPuDb0Q6-aOQGQ',
      icon2: 'mock/gmrfid-service-goods/service/lW9IzySlSYyeBlV0SCA87w',
      id: '619e206806a549793810b034',
      method: 'GET',
      name: '系统设置',
      quickEntry: false,
      serviceName: 'gmrfid-service-user',
      sort: 400,
      type: 'MENU',
      uri: '/systemSettings',
      value: '/systemSettings',
    },
  ],
};
